export default "__VITE_ASSET__C0wt9VZe__"